import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function normalizeCommunityId(communityId) {
  return communityId === '-1' || communityId === -1 ? '' : communityId
}

function setCommunityIdIfValid(target, communityId) {
  const value = normalizeCommunityId(communityId)
  if (value) {
    target.communityId = value
  } else {
    delete target.communityId
  }
}

// 获取报修师傅列表
export function listRepairTypeUsers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/repair.listRepairTypeUsers',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存报修师傅
export function saveRepairTypeUser(data) {
  setCommunityIdIfValid(data, data.communityId || getCommunityId())
  return new Promise((resolve, reject) => {
    request({
      url: '/repair.saveRepairTypeUser',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新报修师傅
export function updateRepairTypeUser(data) {
  setCommunityIdIfValid(data, data.communityId || getCommunityId())

  return new Promise((resolve, reject) => {
    request({
      url: '/repair.updateRepairTypeUser',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除报修师傅
export function deleteRepairTypeUser(data) {
  setCommunityIdIfValid(data, data.communityId || getCommunityId())

  return new Promise((resolve, reject) => {
    request({
      url: '/repair.deleteRepairTypeUser',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取组织树
export function listOrgTree(params) {
  
  return new Promise((resolve, reject) => {
    request({
      url: '/org.listOrgTree',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取员工信息
export function getStaffInfos(params = {}) {
  // 添加必需的分页参数
  const requestParams = {
    page: params.page || 1,
    row: params.row || 999, // 默认获取999条，确保获取所有数据
    ...params
  }

  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params: requestParams
    }).then(response => {
      // 返回完整的响应数据对象
      resolve(response.data || {})
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取员工关联小区
export function listStaffCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/role.listStaffCommunity',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
